import { Link } from 'react-router-dom';

const UsageMeter = ({ usage, compact = false }) => {
  if (!usage) return null;

  const { used = 0, limit, unlimited, atCap, remaining, planName } = usage;
  const label = unlimited
    ? `${used} invoices this month · Unlimited`
    : `${used} of ${limit} invoices this month`;
  const percent = unlimited || !limit ? 0 : Math.min(100, Math.round((used / limit) * 100));
  const warn = !unlimited && remaining !== null && remaining <= 2;

  return (
    <div
      className={`rounded-lg border p-4 ${
        atCap
          ? 'bg-red-50 border-red-200'
          : warn
            ? 'bg-yellow-50 border-yellow-200'
            : 'bg-white border-gray-200'
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="text-sm font-medium text-gray-900">
            {planName || 'Free'} plan
          </p>
          <p className="text-sm text-gray-600 mt-0.5">{label}</p>
        </div>
        {atCap && (
          <Link to="/subscriptions" className="btn btn-primary text-sm whitespace-nowrap">
            Upgrade
          </Link>
        )}
      </div>
      {!unlimited && (
        <div className="mt-3 h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className={`h-full ${atCap ? 'bg-red-500' : warn ? 'bg-yellow-500' : 'bg-primary-600'}`}
            style={{ width: `${percent}%` }}
          />
        </div>
      )}
      {atCap && !compact && (
        <p className="text-sm text-red-700 mt-2">
          You&apos;ve reached your monthly limit of {limit} invoices. Upgrade your plan to create more invoices.
        </p>
      )}
    </div>
  );
};

export default UsageMeter;
